import firebase from 'firebase/app';
import 'firebase/functions';
import parentBookingService from '@/app-template/lib/services/BookingService';

export default {
  ...parentBookingService,
}